import * as runtimeProcess from 'process';

export const DEFAULT_CONTENTSTACK_BRANCH = 'main';

/**
 * Resolves which Contentstack branch to fetch content from.
 *
 * Defaults to `main`. Set `CONTENTSTACK_BRANCH` (e.g. to `ela`) to point fetches
 * at a different branch for testing new content without a code change. Only the
 * GraphQL content-fetching path honours the branch (passed as the `branch`
 * request header); the REST path has no branch support.
 */
export const getContentstackBranch = (): string =>
  runtimeProcess.env.CONTENTSTACK_BRANCH || DEFAULT_CONTENTSTACK_BRANCH;
